import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {
  loadingSub: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  loadingLocalSub: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );
  public readonly loading$ = this.loadingSub.asObservable();
  public readonly loadingLocal$ = this.loadingLocalSub.asObservable();

  constructor() {}

  showSpinner() {
    this.loadingSub.next(true);
  }

  hideSpinner() {
    this.loadingSub.next(false);
  }
  showLocalSpinner() {
    this.loadingSub.next(true);
  }

  hideLocalSpinner() {
    this.loadingLocalSub.next(false);
  }
}
